// Copyright 2017 Sorama B.V.

import { MetadataValuePair } from "datatypes/MetadataFields";
import { RecordingStep } from "datatypes/ScanStep";
import { Container } from "datatypes/SoramaLocalApi";
import {
    AudioMeasurementDataLayout,
    AudioMeasurementDataUnit,
    ComputedMeasurementProperties,
    GenericMeasurement,
    MeasurementMediaObjectLink,
    MeasurementPart,
    Point3D,
    URAProperties,
    VideoMeasurementDataFormat,
} from "datatypes/SoramaWebApi";

abstract class Metadata {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    files: any;
}

export class RecordingMetadata extends Metadata {
    name: string;
    notes: string;
    distance: number;
    sampleRate?: number;
    metadata: MetadataValuePair[] = [];
}

export class RecordingGroupMetadata extends RecordingMetadata {
    recordings: string[] = [];
    steps: RecordingStep[] = [];

    projectIds: string[] = [];
    measurementTypes: string[] = [];
    measurementIds: string[] = [];
}

export class MeasurementMetadata extends Metadata implements GenericMeasurement {
    audioDataUnit: AudioMeasurementDataUnit;
    audioDataLayout: AudioMeasurementDataLayout;
    videoDataFormat: VideoMeasurementDataFormat;
    id: string;
    projectId: string;
    ownerId: string;
    sorId: string;
    name: string;
    notes: string;
    start: Date;
    created: Date;
    isUra: boolean;
    isComputedMeasurement: boolean;
    duration: number;
    distance: number;
    parts: MeasurementPart[];
}

export abstract class MetadataContainer<T> implements Container {
    id: string;
    created: Date;
    contents: string[];
    metadata: T;
}

export class MeasurementContainer extends MetadataContainer<MeasurementMetadata> {}

export class RecordingContainer extends MetadataContainer<RecordingMetadata> {}

export class RecordingGroupContainer extends MetadataContainer<RecordingGroupMetadata> {
    recordings?: RecordingContainer[];
}
